import { useSearchParams } from "react-router-dom";
import { PageHero, usePageMeta } from "@/components/site/PageHero";
import { Booking } from "@/components/site/Booking";

export default function BookingPage() {
  const [params] = useSearchParams();
  usePageMeta("Rezervasyon", "Enduro tur, eğitim veya çocuk eğitimi için tarih seç, rezervasyon talebini gönder — FX Motor Sporları.");
  return (
    <>
      <PageHero eyebrow="Rezervasyon" title="Tarihini seç, parkurda buluşalım." img="/ig/ig00.jpg" alt="Ormanda zıplayan enduro sürücüsü" crumbs={[{ label: "Rezervasyon" }]} />
      <Booking defaultService={params.get("hizmet")} asPage />
    </>
  );
}
